import { render, staticRenderFns } from "./activeSwitch.vue?vue&type=template&id=3c11dd3d"
import script from "./activeSwitch.vue?vue&type=script&lang=js"
export * from "./activeSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports